import React, { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";
import InputWithLabel from "../../../../components/inputWithLabel";
import { useForm } from "react-hook-form";
import axios from "axios";
import { serverUrl } from "../../../../helpers/utility";
import { mutate } from "swr";

function InviteForm({ user }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmitError(null);
    setSubmitSuccess(false);

    try {
      const response = await axios.post(`${serverUrl}/provider/invite`, {
        email: data.email,
      });

      if (response.data?.success) {
        setSubmitSuccess(true);
        reset();
        // Refresh invites list
        mutate(`${serverUrl}/provider/invites`);
        // Clear success message after 3 seconds
        setTimeout(() => setSubmitSuccess(false), 3000);
      } else {
        setSubmitError(response.data?.message || "Failed to send invite");
      }
    } catch (err) {
      console.error("Error sending invite:", err);
      setSubmitError(
        err.response?.data?.message || "Failed to send invite. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Invite Team Member</h5>
      </Card.Header>
      <Card.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <InputWithLabel
            inputId="email"
            label="Email Address"
            type="email"
            placeholder="colleague@example.com"
            register={register}
            validation={{
              required: "Email is required",
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: "Invalid email address",
              },
            }}
            error={errors.email}
            errorMessage={errors.email?.message}
          />

          <div className="mb-3">
            <small className="text-muted">
              The user will be invited as an <strong>Admin</strong> and will be able to create locations and manage enquiries.
            </small>
          </div>

          {submitError && (
            <Alert variant="danger" className="mb-3">
              {submitError}
            </Alert>
          )}

          {submitSuccess && (
            <Alert variant="success" className="mb-3">
              Invite sent successfully!
            </Alert>
          )}

          <Button
            type="submit"
            variant="primary"
            disabled={isSubmitting}
            className="w-100"
          >
            {isSubmitting ? "Sending..." : "Send Invite"}
          </Button>
        </form>
      </Card.Body>
    </Card>
  );
}

export default InviteForm;

